import { Component, OnDestroy, ViewChild } from '@angular/core';

import { User } from '../../../core/modelos/user';
import { Activo } from '../../../core/modelos/activo';
import { CookieService } from 'ngx-cookie-service';
import { Router, NavigationEnd } from '@angular/router';
import { MapaComponent } from '../../components/mapa/mapa.component';
import { PanelInfoComponent } from '../../components/panel-info/panel-info.component';
import { StatsComponent } from '../stats/stats.component';
import { FiltersComponent } from '../filters/filters.component';
import { Platform } from '@angular/cdk/platform';
import { FiltersService } from '../filters/filters.service';
import { ActivosService } from '../activos/activos.service';

@Component({
    selector: 'fuse-portfolio',
    templateUrl: './portfolio.component.html',
    styleUrls: ['./portfolio.component.scss']
})
export class FusePortfolioComponent implements OnDestroy {
    marcadores: any;
    seleccion: number;
    indexPopup: number;
    item: Activo;

    contador = 0;

    navigationSubscription;
    user: User;
    esAdminBod: boolean;
    clienteCookie: string;

    verPanel: boolean = true;
    isListActiveMobile: Boolean;
    isMapActiveMobile: Boolean;

    @ViewChild(MapaComponent) mapa: MapaComponent;
    @ViewChild(PanelInfoComponent) panel: PanelInfoComponent;
    @ViewChild(StatsComponent) stats: StatsComponent;
    @ViewChild(FiltersComponent) filters: FiltersComponent;

    constructor(
        private router: Router,
        private cookieService: CookieService,
        private filtersService: FiltersService,
        private platform: Platform,
        private activosService: ActivosService,
    ) {
        this.user = JSON.parse(sessionStorage.getItem('usuarioLogueado')).usuario;
        this.esAdminBod = this.user.rol.id === 1;

        this.navigationSubscription = this.router.events.subscribe((e: any) => {
            this.verPanel = true;
            this.item = undefined;

            // If it is a NavigationEnd event re-initalise the component
            if (e instanceof NavigationEnd) {
                this.contador++;
                this.initialiseInvites();
            }
        });

        if (this.platform.ANDROID || this.platform.IOS) {
            this.isListActiveMobile = false
            this.isMapActiveMobile = true
        } else {
            this.isListActiveMobile = true
            this.isMapActiveMobile = true
        }

        this.filtersService.view.subscribe(view => {
            this.isListActiveMobile = view === 'list'
            this.isMapActiveMobile = view === 'map'
        })

        // notify about the new activo
        this.activosService.setCurrentActivo(undefined)
    }

    onMarcadores(event: any) {
        this.marcadores = event;
    }

    indexSeleccion(event: number) {
        this.seleccion = event;

        if (event > -1) {
          this.verPanel = false;
        }
    }

    onItemSeleccion(event: Activo) {
        this.item = event;
    }

    onIndexPopup(event: any) {
        this.indexPopup = event;
    }

    initialiseInvites() {
        this.clienteCookie = this.cookieService.get('clienteAdmin');
        // Set default values and re-fetch any data you need.
        if (this.contador > 1 && this.esAdminBod && this.clienteCookie) {
            this.mapa.destruir();
            if (this.panel.verDetalle) {
                this.panel.mostrarListado();
            }

            this.panel.getActivos();
            this.mapa.rellenarMapa();
            this.filters.getFilters();
        }
    }
    ngOnDestroy() {
        // avoid memory leaks here by cleaning up after ourselves. If we
        // don't then we will continue to run our initialiseInvites()
        // method on every navigationEnd event.
        if (this.navigationSubscription) {
            this.navigationSubscription.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/portfolio/portfolio.component.ts